
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OfferSingle } from "@/services/offers/OfferSingle";
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import CardNotes from "@/components/base/CardNotes.vue";
import NotesTooltip from "@/components/base/NotesTooltip.vue";
import ImageNotesFile from "@/components/base/ImageNotesFile.vue";
import { Note } from "@/api/types/notes";
import { showNotification, showServerError } from "@/utils";
import { deleteNote, editNote } from "@/api/notes";

@Component({
    components: {
        ImageNotesFile, NotesTooltip, CardNotes,
        TableWithFrontPaginationDesign,
    },
})
export default class OfferCardNotes extends Vue {
    @Prop({ required: true }) offer!: OfferSingle;

    headers = [
        { text: 'Дата', value: 'created_at', sortable: false, align: 'start', width: '100px' },
        { text: 'Автор', value: 'created_by.name', sortable: false, width: '100px' },
        { text: 'Заметка', value: 'text', sortable: false },
        { text: 'Файл' , value: 'image', sortable: false, align: 'center' },
        { text: '', value: 'actions', sortable: false, width: '40px' },
    ];
    timeData = [
        {
            slot: 'item.created_at',
            key: 'created_at',
            isLine: false,
        },
    ];

    async deleteNote(note: Note): Promise<void> {
        try {
            await deleteNote(note.id);
            showNotification('Заметка успешно удалена');
            await this.offer.getNotes();
        } catch (err) {
            showServerError(err, 'Ошибка удаления заметки');
        }
    }

    async saveNote(note: Note): Promise<void> {
        try {
            await editNote(note.id, { text: note.text, image: note.image });
            showNotification('Заметка отредактирована');
            await this.offer.getNotes();
        } catch (err) {
            showServerError(err, 'Ошибка редактирования заметки');
        }
    }

    addNote(note: string, image: any): void {
        this.offer.createNotes(note, image);
    }
}
